/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './surgical-appointment-attribute-type.reducer';

export const SurgicalAppointmentAttributeTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surgicalAppointmentAttributeTypeEntity = useAppSelector(state => state.surgicalAppointmentAttributeType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surgicalAppointmentAttributeTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.detail.title">
            SurgicalAppointmentAttributeType
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.id">Id</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.name">Name</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.description">Description</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.description}</dd>
          <dt>
            <span id="format">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.format">Format</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.format}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.sortOrder}</dd>
          <dt>
            <span id="retiredReason">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.retiredReason">Retired Reason</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.retiredReason}</dd>
          <dt>
            <span id="retired">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.retired">Retired</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.retired ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.active">Active</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.addedBy">Added By</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.addedBy ? surgicalAppointmentAttributeTypeEntity.addedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.modifiedBy">Modified By</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.modifiedBy ? surgicalAppointmentAttributeTypeEntity.modifiedBy.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.hospital">Hospital</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.hospital ? surgicalAppointmentAttributeTypeEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.theatre">Theatre</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.theatre ? surgicalAppointmentAttributeTypeEntity.theatre.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.surgicalAppointmentAttributeType.procedure">Procedure</Translate>
          </dt>
          <dd>{surgicalAppointmentAttributeTypeEntity.procedure ? surgicalAppointmentAttributeTypeEntity.procedure.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/surgical-appointment-attribute-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/surgical-appointment-attribute-type/${surgicalAppointmentAttributeTypeEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurgicalAppointmentAttributeTypeDetail;
